import { NgModule } from '@angular/core'
import { FloIsIconPipe, FloIsImagePipe, FloIsLinkPipe, FloIsTextPipe } from './flo-typeguards.pipe'

@NgModule({
  declarations: [FloIsIconPipe, FloIsImagePipe, FloIsLinkPipe, FloIsTextPipe],
  exports: [FloIsIconPipe, FloIsImagePipe, FloIsLinkPipe, FloIsTextPipe]
})
export class FloTypeGuardModule {}
